import { Helmet } from "react-helmet-async";
import { AppProviders } from "contexts";
import { GlobalErrorBoundary } from "features/misc";
import { StagingSignIn, useStagingSignIn } from "features/stagingSignIn";
import { Router } from "./Router";

function App() {
  const { showStagingSignIn, ...props } = useStagingSignIn();

  return (
    <GlobalErrorBoundary>
      <AppProviders>
        <Helmet titleTemplate="%s | The HUG" defaultTitle="Welcome to the HUG">
          <meta
            name="description"
            content="Supporting NFT creators and collectors through community research, growth accelerator and advisory programs, and lots of hugs."
          />
        </Helmet>

        {showStagingSignIn ? <StagingSignIn {...props} /> : <Router />}
      </AppProviders>
    </GlobalErrorBoundary>
  );
}

export { App };
